import { useState, useEffect } from "react";
import { Input } from "@heroui/input";
import { Popover, PopoverTrigger, PopoverContent } from "@heroui/popover";
import { Calendar } from "@heroui/calendar";
import { parseDate } from "@internationalized/date";
import { CalendarIcon } from "lucide-react";

export default function DatePickerLike({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (!value) {
      setSelected(null);
      return;
    }
    try {
      setSelected(parseDate(value));
    } catch {
      setSelected(null);
    }
  }, [value]);

  const handleSelect = (dateValue) => {
    if (!dateValue) return;
    setSelected(dateValue);
    onChange?.(dateValue.toString());
    setOpen(false);
  };

  return (
    <Popover placement="bottom-start" isOpen={open} onOpenChange={setOpen} offset={6} classNames={{ backdrop: "bg-black/30" }} backdrop={"blur"}>
      <PopoverTrigger>
        <div
          className="w-full cursor-pointer inline-block"
          onClick={() => setOpen(true)}
        >
          <Input
  value={selected ? selected.toString().split("T")[0] : ""} // show YYYY-MM-DD when selected
  placeholder="Select date"
  readOnly
  variant="bordered"
  className="w-full"
  classNames={{
    inputWrapper: `
      bg-white border border-neutral-200 hover:bg-neutral-100 shadow-sm rounded-xl
      dark:bg-content1 dark:border-default-200/50 dark:hover:bg-content2/70 dark:shadow-none
      transition-colors duration-200
    `,
    input: "text-neutral-900 placeholder:text-neutral-400 dark:text-neutral-100",
    label: "text-neutral-600 dark:text-neutral-400",
  }}
/>
        </div>
      </PopoverTrigger>

      <PopoverContent
        className="
          p-0 overflow-hidden rounded-xl shadow-lg
          border border-neutral-200 bg-white
          dark:border-default-200/40 dark:bg-content1
        "
        style={{ width: "min(22rem, calc(100vw - 2rem))" }}
      >
        <Calendar
          aria-label="Select date"
          value={selected}
          onChange={handleSelect}
          classNames={{
    base: "w-full p-2",
    header: "px-2 py-2",
    title: "text-neutral-800 dark:text-neutral-100 font-medium",
    nav: "text-neutral-500 dark:text-neutral-400",
    navButton: "rounded-md hover:bg-neutral-100 dark:hover:bg-content2",
    gridHeader: "text-neutral-500 dark:text-neutral-400 font-medium",
    cell: "rounded-md transition-colors hover:bg-neutral-100 dark:hover:bg-content2 data-[selected]:bg-primary data-[selected]:text-white",
  }}
        />
      </PopoverContent>
    </Popover>
  );
}